export default __webpack_public_path__ + "74a3b38.png";